import React from "react"
import SEO from "../components/seo"
import Layout from "../components/layout"
import FacebookIcon from "../components/icons/facebookIcon"
import MapIcon from "../components/icons/mapIcon"
import JoinIcon from "../components/icons/joinIcon"
import ContactIcon from "../components/icons/contactIcon"
import FadeIn from "react-fade-in"
import "./contact.css"
import {
  Card,
  CardText,
  CardBody,
  CardTitle,
  CardHeader,
  CardDeck,
} from "reactstrap"

export default class Contact extends React.Component {
  constructor(props) {
    super(props)
    this.state = { mounted: false }
  }
  componentDidMount() {
    this.setState({ mounted: true })
  }

  fbWidthCalc() {
    var parentW = document.getElementById("facebook-page-wrapper").clientWidth
    if (parentW > 500) {
      parentW = 500
    }
    return parentW - 20
  }

  loadFacebookPage() {
    if (this.state.mounted) {
      return (
        <iframe
          title="facebook-page"
          src={
            "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FMarsdenParkRFS%2F&tabs=timeline&width=" +
            this.fbWidthCalc().toString() +
            "&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=false&appId=1139297582907282"
          }
          width={this.fbWidthCalc().toString()}
          height="500"
          style={{ border: "none", overflow: "hidden" }}
          scrolling="no"
          frameBorder="0"
          allowtransparency="true"
          allow="encrypted-media"
        ></iframe>
      )
    } else {
      return <div>loading</div>
    }
  }
  render() {
    return (
      <Layout>
        <SEO title="Contact Us" description="Marsden Park RFS Contact Page" />
        <div style={{ paddingBottom: "1rem", paddingTop: "1rem" }}>
          <FadeIn>
            <CardDeck>
              <Card>
                <CardHeader className="pb-0">
                  <div style={{ float: "left" }}>
                    <ContactIcon />
                  </div>
                  <CardTitle className="contact-card-title">
                    Contact Us
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <div className="text-center pb-4">
                    <div className="contact-item">Address</div>
                    <a
                      href="https://www.google.com/maps/place/Marsden+Park+Rural+Fire+Brigade/@-33.6958619,150.8328224,15z/data=!4m5!3m4!1s0x0:0x1ee7947836ad0b6f!8m2!3d-33.6958619!4d150.8328224"
                      className="contact-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      359 Garfield Rd W, Marsden Park NSW 2765
                    </a>
                  </div>
                  <div className="text-center pb-4">
                    <div className="contact-item">Phone</div>
                    <div>
                      <a className="contact-link" href="tel:+610296272447">
                        9627 2442
                      </a>
                    </div>
                  </div>
                  <div className="text-center pb-4">
                    <div className="contact-item">Email</div>
                    <a
                      className="contact-link"
                      href="mailto:marsdenparkrfb@gmail.com"
                    >
                      marsdenparkrfb@gmail.com
                    </a>
                  </div>
                </CardBody>
              </Card>
              <Card>
                <CardHeader className="pb-0">
                  <div style={{ float: "left" }}>
                    <MapIcon />
                  </div>
                  <CardTitle className="contact-card-title">Find us</CardTitle>
                </CardHeader>
                <CardBody>
                  <CardText>
                    <a
                      href="https://www.google.com/maps/place/Marsden+Park+Rural+Fire+Brigade/@-33.6958619,150.8328224,15z/data=!4m5!3m4!1s0x0:0x1ee7947836ad0b6f!8m2!3d-33.6958619!4d150.8328224"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://maps.googleapis.com/maps/api/staticmap?center=Marsden+Park+Rural+Fire+Brigade&markers=-33.6958619,150.8328224&zoom=15&size=419x400&key=AIzaSyB_A50FzGr2tjSvcjjDMQMv1pjInmQ3Veg"
                        alt="Marsden Park RFSA Location"
                      />
                    </a>
                  </CardText>
                </CardBody>
              </Card>
            </CardDeck>
          </FadeIn>
        </div>
        <FadeIn>
          <div style={{ paddingBottom: "1rem" }}>
            <Card>
              <CardHeader className="pb-0">
                <div style={{ float: "left" }}>
                  <FacebookIcon />
                </div>
                <CardTitle className="contact-card-title">Facebook</CardTitle>
              </CardHeader>
              <CardBody>
                <center>
                  <div id="facebook-page-wrapper" width="100%">
                    {this.loadFacebookPage()}
                  </div>
                  <iframe
                    title="facebook-recommend-share"
                    src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2FMarsdenParkRFS%2F&width=182&layout=button&action=recommend&size=large&share=true&height=30&appId"
                    width="182"
                    height="30"
                    style={{
                      border: "none",
                      overflow: "hidden",
                      marginBottom: "0",
                    }}
                    scrolling="no"
                    frameBorder="0"
                    allowtransparency="true"
                    allow="encrypted-media"
                  ></iframe>
                </center>
              </CardBody>
            </Card>
          </div>
          <div style={{ paddingBottom: "1rem" }}>
            <Card>
              <CardHeader className="pb-0">
                <div style={{ float: "left" }}>
                  <JoinIcon />
                </div>
                <CardTitle className="contact-card-title">Join us</CardTitle>
              </CardHeader>
              <CardBody>
                <CardText>
                  For those who are interested in joining the Brigade, we
                  encourage you to either visit us at the station, or to call or
                  email us and we will be able to assist you with the next steps
                  in joining our team. We train from 19:30 to 21:00 at the
                  station on Wednesdays.
                </CardText>
              </CardBody>
            </Card>
          </div>
        </FadeIn>
      </Layout>
    )
  }
}
